
export default class QueryTableUtil
{
    doMainTables=[]; 
    getQueryTableParams(queryTable){
            var ob = {
                "doMain":queryTable.doMain,
                "tableName":this.getDBTableFiledName(queryTable.tableName),
                "isDirect":queryTable.isDirect
            };
            this.doMainTables.push(ob);
            let queryJoins = queryTable.queryJoins;
            for (let i in queryJoins) {
                this.getQueryTableParams(queryJoins[i]);
            }
    }
    getDBTableFiledName(entityName){
        if (entityName.lastIndexOf(".") != -1) {
            let solutionName = entityName.substr(0, entityName.lastIndexOf("."));
            let simpleEntityName = entityName.substr(entityName.lastIndexOf(".")+1);
            solutionName = solutionName.replace(/[\.]/g,"_");
            return solutionName + "$" + simpleEntityName;
        }else { 
            return entityName;

        }
    }

    getDoMainByTableId(entity,queryTable){
        if(entity == queryTable.tableId){
            return queryTable.doMain;
        }else{
            let queryJoins = queryTable.queryJoins;
            for (let i in queryJoins) {
                this.getDoMainByTableId(entity,queryJoins[i]);
            }
        }

    }

    getDoMainByTableId2(entity,queryTable){
        if(entity == queryTable.Properties.Table.refentityid){
            return queryTable.Properties.DoMain.V;
        }else{
            let queryJoins = queryTable.queryJoins;
            for (let i in queryJoins) {
                this.getDoMainByTableId(entity,queryJoins[i]);
            }
        }

    }

}


// WEBPACK FOOTER //
// ./src/universalView/QueryTableUtil.js